<header class="header">
  <picture >
    <source media="(max-width: 600px)" srcset="logo-small.png">
    <img class="logo" ngSrc="logo.png" alt="Lab Appointment Logo" height="130" width="988" priority>
  </picture>
</header>
